import React from 'react'
import styled from 'styled-components'
import { Tooltip, Divider } from 'antd'
import Button from 'components/Button'
import IntenToOfferIcon from 'components/icons/DriveTableIcon/IntentToOffer'
import OfferAcceptedIcon from 'components/icons/DriveTableIcon/OfferAccepted'
import OfferIssuedIcon from 'components/icons/DriveTableIcon/OfferIssued'
import HiredIcon from 'components/icons/DriveTableIcon/Joined'
import LeftedIcon from 'components/icons/DriveTableIcon/Lefted'
import ResumeDownload from '../../../../../components/icons/DriveTableIcon/ResumeDownload'
import { EmptyElement } from '../../../../../components/UIComponents/CommonStyledDiv'

const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  cursor: pointer;
  margin-top: 5px;
  width: 100%;
`

const IconText = styled.h4`
  margin-bottom: 6px;
  color: rgba(128, 134, 151, 1);
`

const StyledDivider = styled(Divider)`
  margin: 0 10px;
  border-color: rgba(223, 223, 223, 1);
  height: 40px;
  align-self: center;
`

// Helper function to count active filter categories
const getActiveFilterCount = (filterValues) => {
  if (!filterValues) return 0;
  
  let activeCount = 0;
  
  // Check array type filters
  const arrayFilters = [
    'selectedRound', 'selectedStatus', 'selectedDegrees', 'selectedDepartments', 
    'selectedSpecializations', 'selectedYears', 'selectedSkills', 'selectedColleges', 
    'selectedCollegeStates', 'selectedCollegeCities', 'selectedGender', 'selectScories',
    'selectedRoundScore', 'selectedQualifyingQuestions', 'selectedPermanentState', 
    'selectedPermanentCity', 'selectedCurrentState', 'selectedCurrentCity', 
    'selectedPreferredLocation', 'selectedFunction', 'selectedRole', 
    'selectedDurationYear', 'selectedDurationMonth'
  ];
  
  arrayFilters.forEach(filter => {
    if (Array.isArray(filterValues[filter]) && filterValues[filter].length > 0) {
      activeCount++;
    }
  });
  
  // Check object type filters
  if (filterValues.selectedAge && (filterValues.selectedAge.from || filterValues.selectedAge.to)) {
    activeCount++;
  }
  
  if (filterValues.selectedQuickAge && (filterValues.selectedQuickAge.from || filterValues.selectedQuickAge.to)) {
    activeCount++;
  }
  
  // Check other specific filters
  if (filterValues.selectedScoreFilterType) activeCount++;
  if (filterValues.selectedCurrentArrearFilterType) activeCount++;
  if (filterValues.selectedPastArrearFilterType) activeCount++;
  if (filterValues.selectedCurrentArrearCount !== null && filterValues.selectedCurrentArrearCount !== undefined) activeCount++;
  if (filterValues.selectedPastArrearCount !== null && filterValues.selectedPastArrearCount !== undefined) activeCount++;
  if (filterValues.includeArrears) activeCount++;
  
  return activeCount;
};

export default function OfferTableStatusIcon({
  onChange,
  status,
  selectedCandidateId,
  candidateStatus,
  handleDownload,
  conflictData,
  handleResolveConflict,
  filterValues
}) {
  return ( 
    <IconContainer>
      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        <IconText style={{ whiteSpace: 'nowrap' }}>Select status</IconText>
        
        {(status === 'ACTIVE' ||
          status === 'ACCEPTED' ||
          status === 'JOINED' ||
          status === 'LEFTED' ||
          status === 'REJECTED') && (
          <EmptyElement
            onClick={
              selectedCandidateId?.length === 0 || candidateStatus?.includes('RELEASED')
                ? undefined
                : () => onChange('RELEASED')
            }
            style={{
              pointerEvents: 'auto',
              opacity:
                selectedCandidateId?.length === 0 || candidateStatus?.includes('RELEASED')
                  ? '0.5'
                  : '',
            }}
          >
            <IntenToOfferIcon />
          </EmptyElement>
        )}
        
        {(status === 'RELEASED' ||
          status === 'ACTIVE' ||
          status === 'LEFTED' ||
          status === 'REJECTED') && (
          <EmptyElement
            onClick={
              selectedCandidateId?.length === 0 || candidateStatus?.includes('ACCEPTED')
                ? undefined
                : () => onChange('ACCEPTED')
            }
            style={{
              pointerEvents: 'auto',
              opacity:
                selectedCandidateId?.length === 0 || candidateStatus?.includes('ACCEPTED')
                  ? '0.5'
                  : '',
            }}
          >
            <OfferAcceptedIcon />
          </EmptyElement>
        )}
        
        {(status === 'RELEASED' ||
          status === 'ACTIVE' ||
          status === 'JOINED' ||
          status === 'REJECTED' ||
          status === 'LEFTED' ||
          status === 'ACCEPTED') && (
          <EmptyElement
            onClick={
              selectedCandidateId?.length === 0 || candidateStatus?.includes('REJECTED')
                ? undefined
                : () => onChange('REJECTED')
            }
            style={{
              pointerEvents: 'auto',
              opacity:
                selectedCandidateId?.length === 0 || candidateStatus?.includes('REJECTED')
                  ? '0.5'
                  : '',
            }}
          >
            <OfferIssuedIcon />
          </EmptyElement>
        )}
        {(
          status === 'RELEASED' ||
          status === 'ACTIVE' ||
          status === 'REJECTED' ||
          status === 'LEFTED' ||
          status === 'ACCEPTED') && (
          <EmptyElement
            onClick={
              selectedCandidateId?.length === 0 || candidateStatus?.includes('JOINED')
                ? undefined
                : () => onChange('JOINED')
            }
            style={{
              pointerEvents: 'auto',
              opacity:
                selectedCandidateId?.length === 0 || candidateStatus?.includes('JOINED')
                  ? '0.5'
                  : '',
            }}
          >
            <HiredIcon />
          </EmptyElement>
        )}
        {(status === 'RELEASED' ||
          status === 'ACTIVE' ||
          status === 'JOINED' ||
          status === 'ACCEPTED') && (
          <EmptyElement
            onClick={
              selectedCandidateId?.length === 0 || candidateStatus?.includes('LEFTED')
                ? undefined
                : () => onChange('LEFTED')
            }
            style={{
              pointerEvents: 'auto',
              opacity:
                selectedCandidateId?.length === 0 || candidateStatus?.includes('LEFTED')
                  ? '0.5'
                  : '',
            }}
          >
            <LeftedIcon />
          </EmptyElement>
        )}
        <>
          <StyledDivider type="vertical" />
          <EmptyElement
            onClick={
              selectedCandidateId?.length === 0
                ? undefined
                : () => handleDownload()
            }
            style={{
              pointerEvents: 'auto',
              opacity:
                selectedCandidateId?.length === 0
                  ? '0.5'
                  : '',
            }}
          >
            <ResumeDownload />
          </EmptyElement>
        </>

        {getActiveFilterCount(filterValues) > 0 && (
          <>
            <StyledDivider type="vertical" />
            <IconText style={{ whiteSpace: 'nowrap' }}>Selected Filter Count: {getActiveFilterCount(filterValues)}</IconText>
          </>
        )}
      </div>
    </IconContainer>
  )
}
